import moment from 'moment';
import React, {useEffect, useState} from 'react'
import {useLocation, Link, useHistory} from 'react-router-dom';
import firebase from '../../firebase/config'
import Jitsi from 'react-jitsi'

function Order() {

    const data = useLocation()
    const history = useHistory()

    let todayDate = moment().format("ddd, MMM D YYYY, hh:mm").toString()
    let metodosPago = ["Tarjeta de crédito", "Master", "Visa", "American", "Diners", "Efectivo", "Tarjeta de débito", "Otro"]


    const [user, setUser] = useState({})
    const [orderSell, setOrderSell] = useState({})
    const [order, setOrder] = useState({})
    const [itemsProducts, setItemsProducts] = useState([])
    const [comentario, setComentario] = useState("")
    const [modal, setModal] = useState(false)
    const [success, setSuccess] = useState(false);
    const [successMsg, setSuccessMsg] = useState("");
    const [displayName, setDisplayName] = useState('')
    const [roomName, setRoomName] = useState('')
    const [password, setPassword] = useState('')
    const [onCall, setOnCall] = useState(false)
    const [loadingComplete, setLoadingComplete] = useState(false)
    const [modalPago, setModalPago] = useState(false)
    const [countryInfo, setCountryInfo] = useState({})
    const [infoPago, setInfoPago] = useState({
      metodoPago: "",
      referencia: "",
      monto: 0,
      fecha: todayDate,
    })

    const handleAPI = (JitsiMeetAPI) => {
      setLoadingComplete(true)
      JitsiMeetAPI.executeCommand('toggleVideo')
      setLoadingComplete(false)
    }

    const getOrder = async(oid) =>{
      try {
        await firebase.db.collection("Ordenes").doc(oid).onSnapshot((val)=>{
          setOrder(val.data())
          getOrderInfo(val.data())
        })
      } catch (e) {
        console.log(e)
      }
    }
    
    const getOrderInfo = async(orderParam) =>{
      let item = {}
      let tiposList = []
      if(orderParam.tipoOrden === "Servicio" || orderParam.tipoOrden === "Videoconsulta"){
        let reference = (await firebase.db.collection("Ordenes").doc(orderParam.oid).collection("Items").get()).docs
        item = reference[0].data()
        try {
          firebase.db.collection("Localidades").doc(orderParam.localidadId).collection("Servicios").doc(item.servicioid).onSnapshot((doc)=>{
            setOrderSell(doc.data() ?? {})
          })
        }catch(e){
          console.log(e)
        }
      }else if(orderParam.tipoOrden === "Producto"){
        
        await firebase.db.collection("Ordenes").doc(orderParam.oid).collection("Items").get().then((val)=>{
          Promise.all(val.docs.map(async (doc) => {
        
            firebase.db.collection("Productos").doc(doc.data().productoId).get().then((d)=>{
              tiposList.push(d.data() ?? {})
            })
            
          }))
          
        })

        setTimeout(() => {
          setItemsProducts(tiposList)
        }, 500);

      }

    }

    const Loader = () => {
      return (
        <div 
        style={{
          position: "absolute",
          zIndex: "-10",
          width: '100%', 
          height: '90vh',
          // top: "0",
          left: "0",
        }}
        className="p404">Cargando, espere un momento...</div>
      )
    }

    const SuccessComponent = ({msg}) => {
      return (
          <div className="success-alert">
              <span className="material-icons mr-2">done</span>
              {msg}
              <div onClick={()=>{setSuccess(false)}} className="material-icons ml-2 cursor-pointer">close</div>
          </div>
      )
    }

    useEffect(() => {
        if(data.state === undefined || data.state === null){
          window.location.href = "/orders"
        }
        firebase.getCurrentUser().then((val)=>{
          setUser(val)
          firebase.getCountryInfo(val.pais).then((val)=>{
            setCountryInfo(val.data())
          })
        })
        getOrder(data.state.oid)
    }, [])
    
    return (
      <div className={`main-content-container ${ !onCall ? "container-fluid px-4" : ""}`}>
        {success && <SuccessComponent msg={successMsg === "" ? "Pago registrado exitosamente" : successMsg}/>}
        { modalPago && <div className="cc-modal-wrapper fadeIn">
          <div className="c2-modal">
              <div className="cc-modal-header mb-2">
                  <h3 className="mb-0">Registro de pago</h3>
              </div>
              <div className="email-box my-3">

                <select onChange={(e)=>{ setInfoPago({...infoPago, metodoPago: e.target.value}) }} className="form-control mb-4">
                  <option value="">Método de pago</option>
                  {metodosPago.map((met, i)=>{
                    return (
                      <option value={met}>{met}</option>
                    )
                  })}
                </select>
                <input placeholder="Referencia" onChange={(e)=>{ setInfoPago({...infoPago, referencia: e.target.value}) }} type="text" className="form-control mb-4"/>
                <div className="input-group mb-4">
                  <div className="input-group-prepend">
                    <span className="input-group-text">{countryInfo.simbolo ?? " "}</span>
                  </div>
                  <input type="number" onChange={(e)=>{ setInfoPago({...infoPago, monto: e.target.value}) }} placeholder="Monto" className="form-control"/>
                </div>

                <p className="mb-2 color-primary">Fecha: {todayDate}</p>

              </div>
              <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                <button onClick={()=>{setModalPago(false)}} className="btn btn-outline-secondary mr-5">
                  Cancelar
                </button>
                <button onClick={()=>{
                  registerPayment()
                }} className="btn btn-primary btn-block">Registrar</button>
              </div>
          </div>
        </div>}
        { onCall
          ? (
            <Jitsi
              containerStyle={{ 
                width: '100%', 
                height: '90vh', 
                display: "block", 
                position: "absolute",
                zIndex: "111",
                // top: "0",
                left: "0",
              }}
              roomName={roomName}
              config={{ startAudioMuted: true, enableClosePage: true, enableWelcomePage: true }}
              interfaceConfig={{ filmStripOnly: false, SHOW_PROMOTIONAL_CLOSE_PAGE: false, SHOW_BRAND_WATERMARK: false, SHOW_POWERED_BY: false, SHOW_JITSI_WATERMARK: false }}
              displayName={user.nombre}
              password={password}
              loadingComponent={Loader}
              onAPILoad={handleAPI}
            />)
          : (
            <>
            { modal
              ?
                <div className="cc-modal-wrapper fadeIn">
                    <div className="c2-modal">
                        <div className="cc-modal-header mb-2">
                            <h3 className="mb-0">Selecciona una opción</h3>
                        </div>
                        <div className="c2-modal-body">
                           <p className="mb-0">
                            ¿Deseas ingresar a la videoconsulta con tu paciente ahora?
                           </p>
                        </div>

                        <div className="cc-modal-footer align-items-center justify-content-spacebetween">
                          <button onClick={()=>{setModal(false)}} className="btn btn-outline-secondary">
                            Cancelar
                          </button>
                          <button onClick={()=>{ setOnCall(true) }} className={`btn btn-primary`}>
                          Ir a la videoconsulta
                          </button>
                        </div>

                    </div>
                </div>
              : <div></div>
              }
            <div className="page-header align-items-center justify-content-spacebetween row no-gutters px-4 my-4">
              <div className="col-12 col-sm-5 text-center text-sm-left mb-0">
                <div className="row align-items-center">
                  <div className="ml-2 col row">
                    <p className="page-title bold"><Link className="page-title light" to="/orders">Órdenes</Link> <span>Orden</span></p>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-1 mb-0">
                <div className="row align-items-center justify-content-space-around">
                  <i className="material-icons color-white display-5">help_outline</i>
                </div>
              </div>
            </div>
            <h3 className="mb-5">Detalle de la orden</h3>
            <div className="row no-gutters">
              <div className="row col-lg-8 h-fit-content">
                <div className="col-lg-4">
                  <p className="mb-0 bold color-primary">Nombre del cliente</p>
                  <p>{order.user}</p>
                </div>
                <div className="col-lg-4">
                  <p className="mb-0 bold color-primary">Status</p>
                  <p>{order.status}</p>
                </div>
                <div className="col-lg-4">
                  <p className="mb-0 bold color-primary">{order.tipoOrden === "Producto" ? "" : "Fecha" }</p>
                  <p>{order.fecha}</p>
                </div>
                <div className="col-lg-4">
                  <p className="mb-0 bold color-primary">Monto</p>
                  <p>{countryInfo.simbolo ?? " "}{order.precio}</p>
                </div>
                <div className="col-lg-4">
                  <p className="mb-0 bold color-primary">Nro. de órden</p>
                  <p>{order.oid}</p>
                </div>
                <div className="col-lg-4">
                  <p className="mb-0 bold color-primary">Tipo de órden</p>
                  <p>{order.tipoOrden}</p>
                </div>
                <div className=" col-lg-12 row mb-3 align-items-center justify-content-spacebetween">
                  
                  <div className="col-lg-5">
                    <button onClick={()=>{
                      history.push({
                        pathname: "/clients/client", 
                        state: { uid: order.uid }
                      })
                    }} className="btn btn-primary btn-block">Información del cliente</button>
                  </div>
                  
                  { ( order.status === "Por confirmar" || order.status === "Por Confirmar" ) && <div className="col-lg-4">
                    <button onClick={()=>{ updateOrder() }} className="btn btn-outline-secondary btn-block">Confirmar orden</button>
                  </div> }
                  
                  { order.status === "Por cobrar" && <div className="col-lg-4">
                    <button onClick={()=>{ setModalPago(true) }} className="btn btn-outline-secondary btn-block">Registrar pago</button>
                  </div> }

                  { ( ( order.tipoOrden === "Servicio" || order.tipoOrden === "Videoconsulta" ) && order.atendidoStatus === undefined) && <div className="col-lg-3">
                    <button onClick={()=>{ updateEnAtencionOrder() }} className="btn btn-outline-secondary btn-block btn-no-padding-x">
                      Atender
                    </button>
                  </div> }

                  { ( order.tipoOrden === "Producto" && order.atendidoStatus === undefined ) && <div className="col-lg-3">
                    <button onClick={()=>{ updateEnAtencionOrder() }} className="btn btn-outline-secondary btn-block btn-no-padding-x">
                      Despachar
                    </button>
                  </div> }

                </div>
                <div className="col-lg-12 pr-2 border-top">
                  
                  { order.atendidoStatus === "En atención" && <div className="mt-2">
                    <div className="row">
                      <h3 className="mb-4 col-lg-4">
                      {order.tipoOrden === "Producto" ? "Despachado" : "En atención" }
                      </h3>
                      <div className="mb-4 col-lg-4">

                        <div onClick={()=>{updateAtendioOrder()}} className="btn btn-danger">
                          {order.tipoOrden === "Producto" ? "Entregado" : "Cierre de atención" }
                        </div>

                      </div>
                    </div>
                    <h5 className="mb-2">Usuario que { order.tipoOrden === "Producto" ? "despacho" : "esta atendiendo"}:</h5>
                    <p className="mb-4 color-primary">{user.nombre}</p>
                    <h5 className="mb-2">Desde cuando se { order.tipoOrden === "Producto" ? "despacho" : "esta atendiendo"}:</h5>
                    <p className="mb-4 color-primary capitalize">{todayDate}</p>
                  </div> }

                  { order.atendidoStatus === "Atendido" && <div className="mt-2">
                    <h3 className="mb-4">{order.tipoOrden === "Producto" ? "Entregado" : "Atendido"} por: {order.usuarioAtendio}</h3>
                    <h5 className="mb-2">Usuario que {order.tipoOrden === "Producto" ? "entregó" : "atendió"}:</h5>
                    <p className="mb-4 color-primary">{order.usuarioAtendio}</p>
                    <h5 className="mb-2">Cuando se {order.tipoOrden === "Producto" ? "entregó" : "atendió"}:</h5>
                    <p className="mb-4 color-primary capitalize">{order.horaAtendio ?? todayDate}</p>
                    { order.comentario === "" || order.comentario === undefined ? <></> : <h5 className="mb-2">Comentario adicional</h5>}
                    { order.comentario === "" || order.comentario === undefined ? <div className="pr-5">
                      <textarea className="form-control" value={comentario} placeholder="Escribe un comentario referente a este cliente" onChange={(e)=>{setComentario(e.target.value)}} />
                      <div onClick={()=>{ comentario !== "" ? saveComment() : console.log("Error") }} className="btn btn-outline-primary">
                        Guardar comentario
                      </div>
                    </div> : <p className="mb-4 color-primary capitalize">{order.comentario}</p> }
                  </div> }

                </div>
              </div>
              
              <div className="col-lg-4">
                { (order.tipoOrden === "Servicio" || order.tipoOrden === "Videoconsulta" || order.tipoOrden === "videoconsulta") &&
                  <div className="card mb-4"> 
                    <div className="card-header-img-width">
                      <img src={orderSell.urlImagen} alt=""/>
                    </div>
                    <div className="px-4">
                      <div className="card-claim-box">
                        <p className="card-claim-title">{orderSell.categoria}</p>
                        <p className="card-claim-text">{orderSell.titulo}</p>
                      </div>
                      <div className="card-claim-box">
                        <p className="card-claim-title">Precio del servicio</p>
                        <p className="card-claim-text">{countryInfo.simbolo ?? " "}{orderSell.precio}</p>
                      </div>
                      <div className="card-claim-box">
                        <p className="card-claim-title">Descripción del servicio</p>
                        <p className="card-claim-text">{orderSell.descripcion}</p>
                      </div>
                      <div className="card-claim-box">
                        <p className="card-claim-title">Condiciones del servicio</p>
                        <p className="card-claim-text">{orderSell.condiciones}</p>
                      </div>
                    </div>
                  </div>
                }
                { order.tipoOrden === "Producto" &&
                  itemsProducts.map((product, i)=>{
                    let precioRounded = Math.round(product.precio * 100) / 100
                    return (
                      <div className="col-md-12 col-sm-12">
                          <div key={product.productId} className="card-product mb-4">
                              <div className="card-body">
                                  <div className="row">
                                      <div className="col-md-5 col-sm-5">
                                          <div className="card-img h-50">
                                              <img src={product.urlImagen} alt={product.urlImagen}/>
                                          </div>
                                      </div>
                                      <div className="col-md-7 col-sm-7">
                                          <div className="card-product-title">
                                              <p className="card-text">{product.titulo}</p>
                                          </div>
                                          <p className="card-text-type">{product.tipoMascota}</p>
                                          <p className="card-text-price">{countryInfo.simbolo ?? " "}{precioRounded}</p>
                                      </div>
                                  </div>   
                              </div>
                          </div>
                      </div>
                    )
                  })
                }
              </div>
            </div>
              
            </>
          )
        }
      </div>
    )

    async function registerPayment(){
      try {
        await firebase.db.collection("Ordenes").doc(order.oid).update({
          status: "Pagada",
          statusCita: "Pagada",
          statusPago: "Pagada",
          informacionPago: infoPago
        })

        setModalPago(false)
        setSuccessMsg("Pago registrado exitosamente")
        setSuccess(true)
        setTimeout(() => {
          setSuccess(false)
        }, 4000);

      }catch (e){
        console.log(e)
      }
    }
    
    async function updateOrder(){
      try {
        await firebase.db.collection("Ordenes").doc(order.oid).update({
          status: "Confirmada",
          statusCita: "Confirmada"
        })

      }catch (e){
        console.log(e)
      }
    }
    
    async function saveComment(){
      try {
        await firebase.db.collection("Ordenes").doc(order.oid).collection("Items").get().then((val)=>{
          firebase.db.collection("Ordenes").doc(order.oid).update({
            comentario: comentario,
          })
          
          Promise.all(val.docs.map(async (doc) => {
            firebase.db.collection("Ordenes").doc(order.oid).collection("Items").doc(doc.data().servicioid).update({
              comentario: comentario,
            })
          }))

        })
        
      }catch (e){
        console.log(e)
      }
    }
    
    async function updateAtendioOrder(){
      try {
        await firebase.db.collection("Ordenes").doc(order.oid).collection("Items").get().then((val)=>{
          firebase.db.collection("Ordenes").doc(order.oid).update({
            atendidoStatus: "Atendido",
            usuarioAtendio: user.nombre,
            comentario: comentario,
            horaAtendio: todayDate,
          })

          if( order.tipoOrden === "Producto" ){
            firebase.db.collection("Ordenes").doc(order.oid).update({
              status: "Entregado",
              statusCita: "Entregado"
            })
          }else{
            firebase.db.collection("Ordenes").doc(order.oid).update({
              status: "Atendido",
              statusCita: "Atendido"
            })
          }

          Promise.all(val.docs.map(async (doc) => {
            firebase.db.collection("Ordenes").doc(order.oid).collection("Items").doc(doc.data().servicioid).update({
              atendidoStatus: "Atendido",
              usuarioAtendio: user.nombre,
              comentario: comentario,
              horaAtendio: todayDate,
            })
          }))

        })
        
      }catch (e){
        console.log(e)
      }
    }

    async function updateEnAtencionOrder(){
      try {
        await firebase.db.collection("Ordenes").doc(order.oid).collection("Items").get().then((val)=>{
          firebase.db.collection("Ordenes").doc(order.oid).update({
            atendidoStatus: "En atención",
            usuarioAtendio: user.nombre,
            comentario: comentario,
            horaAtendio: todayDate,
          })

          if( order.tipoOrden === "Producto" ){
            firebase.db.collection("Ordenes").doc(order.oid).update({
              status: "Despachado",
              statusCita: "Despachado"
            })
          }else{
            firebase.db.collection("Ordenes").doc(order.oid).update({
              status: "En atención",
              statusCita: "En atención"
            })
          }
          
          Promise.all(val.docs.map(async (doc) => {
            firebase.db.collection("Ordenes").doc(order.oid).collection("Items").doc(doc.data().servicioid).update({
              atendidoStatus: "En atención",
              usuarioAtendio: user.nombre,
              comentario: comentario,
              horaAtendio: todayDate,
            })
          })).then((val)=>{
            
            if(order.tipoOrden === "Videoconsulta" || order.tipoOrden === "videoconsulta"){
              firebase.db.collection("Mascotas").doc(order.mid).collection("Calendar").doc(order.videoId).update({
                done: true
              })
              setRoomName(order.videoId)
              setModal(true)
            }

          })
        })
        
      }catch (e){
        console.log(e)
      }
    }

}

export default Order